import { InvoiceTypePipe } from './invoice.type.pipe';

export function InvoiceTypeFilter ( invoiceTypePipe : InvoiceTypePipe ) {
  return ( value : string ) : string => invoiceTypePipe.transform(value);
}